// ⛔️Generated file. Manual changes will be lost ⛔️

export class UserDecisionScreens {
    public static readonly ScriptSelection: string = 'SCRIPT_SELECTION';
}
